import { uniq } from 'lodash';
const areDifferent = (val1, val2) => {
  if (val1 instanceof Date && val2 instanceof Date) {
    return val1.getTime() !== val2.getTime();
  } else {
    return val1 !== val2;
  }
};
export const getBiParamsDiff = function (biParams1, biParams2, includeNullifiedFields) {
  if (includeNullifiedFields === void 0) {
    includeNullifiedFields = false;
  }
  const allFields = uniq([...Object.keys(biParams1), ...Object.keys(biParams2)]);
  return allFields.reduce((diff, key) => (biParams2[key] !== undefined || includeNullifiedFields) && areDifferent(biParams1[key], biParams2[key]) ? `${diff}${diff ? ',' : ''}${key}` : diff, '');
};
//# sourceMappingURL=get-bi-params-diff.js.map